import CalmHealthBreatheBubble from '@/components/breatheBubble/calmHealthBreatheBubble';
import { BubbleContainer } from '@/components/breatheBubble/calmHealthBreatheBubble/styles';

import BackgroundContainer from './BackgroundContainer';

const Breathe = () => (
	<BackgroundContainer>
		<BubbleContainer>
			<CalmHealthBreatheBubble maxBreaths={0} />
		</BubbleContainer>
	</BackgroundContainer>
);

export default Breathe;
